import { IMAGES } from "../../lzapp_web_common_code/assets";
import {
    PRACTICE_TEST,
    APP_DOMAIN_LIST,
    QUESTION_VERSION_OF_JSON,
} from '../_shared/sie.data'

export { PRACTICE_TEST, APP_DOMAIN_LIST, QUESTION_VERSION_OF_JSON }

export const GET_FLASH_CARD_MENU = () => {
  return [
    {
      title: "Bookmark",
      image: IMAGES?.ic_flash_bookmark,
      menu: null,
      key: "bookmark",
      requires_subscription: false,
    },
    {
      title: "Quick Set (10)",
      image: IMAGES?.ic_flash_quick_set,
      menu: null,
      key: "quick",
      requires_subscription: false,
    },
    {
      title: "All Flashcards",
      image: IMAGES?.ic_flash_exam,
      menu: null,
      key: "all_cards",
      requires_subscription: false,
    },
  ];
};

export const GET_STUDY_QUESTION_MENU = () => {
  return [
    {
      title: "Bookmark",
      image: IMAGES?.ic_flash_bookmark,
      key: "bookmark",
      menu: APP_DOMAIN_LIST
    },
    {
      title: "Quick Set (10)",
      image: IMAGES?.ic_flash_quick_set,
      menu: null,
      key: "quick",
    },
    {
      title: 'By Topics (Free Plan)',
      key: 'by_topic_free_model',
      image: IMAGES?.ic_flash_topic,
      free_model: 1,
      menu: APP_DOMAIN_LIST
  },
  {
      title: 'By Topics (Premium Plan)',
      key: 'by_topic',
      image: IMAGES?.ic_flash_topic,
      menu: APP_DOMAIN_LIST
  },
  ];
};
